import { Authorization } from './Authorization/Authorization'
import { Group } from './Group/Group'
import { PassportConfiguration } from './PassportConfiguration/PassportConfiguration'
import { Passport } from './Passport/Passport'
import { Role } from './Role/Role'
import { RoleTemplate } from './RoleTemplate/RoleTemplate'
import { Map3D } from './Map3D/Map3D'
import { Map } from './Map/Map'
import { PointOfView } from './PointOfView/PointOfView'
import { LocationHistory } from './LocationHistory/LocationHistory'
import { LocationHistoryRegistration } from './LocationHistoryRegistration/LocationHistoryRegistration'
import { Marker } from './Marker/Marker'
import { Drawing } from './Drawing/Drawing'
import { Geofence } from './Geofence/Geofence'
import { Grid } from './Grid/Grid'
import { Layer } from './Layer/Layer'
import { LayerInteractions } from './LayerInteractions/LayerInteractions'
import { MarkerAttachment } from './MarkerAttachment/MarkerAttachment'
import { Track } from './Track/Track'
import { Zone } from './Zone/Zone'
import { Image } from './Image/Image'
import { Path } from './Path/Path'
import { Mission } from './Mission/Mission'
import { MissionTemplate } from './MissionTemplate/MissionTemplate'
import { AgentActivityReport } from './AgentActivityReport/AgentActivityReport'
import { Agent } from './Agent/Agent'
import { AgentStatus } from './AgentStatus/AgentStatus'
import { Camera } from './Camera/Camera'
import { LiveStream } from './LiveStream/LiveStream'
import { PlaybackStream } from './PlaybackStream/PlaybackStream'
import { VideoExport } from './VideoExport/VideoExport'
import { Vms } from './Vms/Vms'
import { Alarm } from './Alarm/Alarm'
import { AlarmSystem } from './AlarmSystem/AlarmSystem'
import { AnalyticsConnector } from './AnalyticsConnector/AnalyticsConnector'
import { AnalyticsCamera } from './AnalyticsCamera/AnalyticsCamera'
import { AnalyticsConfiguration } from './AnalyticsConfiguration/AnalyticsConfiguration'
import { AnalyticsProfile } from './AnalyticsProfile/AnalyticsProfile'
import { AnalyticsResultMedia } from './AnalyticsResultMedia/AnalyticsResultMedia'
import { Attachment } from './Attachment/Attachment'
import { Category } from './Category/Category'
import { Certainty } from './Certainty/Certainty'
import { Log } from './Log/Log'
import { Severity } from './Severity/Severity'
import { Status } from './Status/Status'
import { Channel } from './Channel/Channel'
import { AgentBehaviour } from './AgentBehaviour/AgentBehaviour'
import { Scenario } from './Scenario/Scenario'
import { Simulation } from './Simulation/Simulation'
import { AccessBadgeCarrier } from './AccessBadgeCarrier/AccessBadgeCarrier'
import { AccessBadge } from './AccessBadge/AccessBadge'
import { AccessNotification } from './AccessNotification/AccessNotification'
import { AccessPoint } from './AccessPoint/AccessPoint'
import { Acs } from './Acs/Acs'
import { Diagram } from './Diagram/Diagram'
import { Logs } from './Logs/Logs'
import { Module } from './Module/Module'
import { Process } from './Process/Process'
import { UserTask } from './UserTask/UserTask'
import { UserTaskList } from './UserTaskList/UserTaskList'
import { VariableMessageSign } from './VariableMessageSign/VariableMessageSign'
import { SipCall } from './SipCall/SipCall'
import { SipCallLog } from './SipCallLog/SipCallLog'
import { SipCallSheet } from './SipCallSheet/SipCallSheet'
import { SipLabel } from './SipLabel/SipLabel'
import { SipPhoneConfiguration } from './SipPhoneConfiguration/SipPhoneConfiguration'
import { SipPhoneContact } from './SipPhoneContact/SipPhoneContact'
import { Notification } from './Notification/Notification'
import { NotificationType } from './NotificationType/NotificationType'
import { Connector } from './Connector/Connector'
import { Node } from './Node/Node'
import { Template } from './Template/Template'

export default {
  ...Authorization,
  ...Group,
  ...PassportConfiguration,
  ...Passport,
  ...Role,
  ...RoleTemplate,
  ...Map3D,
  ...Map,
  ...PointOfView,
  ...LocationHistory,
  ...LocationHistoryRegistration,
  ...Marker,
  ...Drawing,
  ...Geofence,
  ...Grid,
  ...Layer,
  ...LayerInteractions,
  ...MarkerAttachment,
  ...Track,
  ...Zone,
  ...Image,
  ...Path,
  ...Mission,
  ...MissionTemplate,
  ...AgentActivityReport,
  ...Agent,
  ...AgentStatus,
  ...Camera,
  ...LiveStream,
  ...PlaybackStream,
  ...VideoExport,
  ...Vms,
  ...Alarm,
  ...AlarmSystem,
  ...AnalyticsConnector,
  ...AnalyticsCamera,
  ...AnalyticsConfiguration,
  ...AnalyticsProfile,
  ...AnalyticsResultMedia,
  ...Attachment,
  ...Category,
  ...Certainty,
  ...Log,
  ...Severity,
  ...Status,
  ...Channel,
  ...AgentBehaviour,
  ...Scenario,
  ...Simulation,
  ...AccessBadgeCarrier,
  ...AccessBadge,
  ...AccessNotification,
  ...AccessPoint,
  ...Acs,
  ...Diagram,
  ...Logs,
  ...Module,
  ...Process,
  ...UserTask,
  ...UserTaskList,
  ...VariableMessageSign,
  ...SipCall,
  ...SipCallLog,
  ...SipCallSheet,
  ...SipLabel,
  ...SipPhoneConfiguration,
  ...SipPhoneContact,
  ...Notification,
  ...NotificationType,
  ...Connector,
  ...Node,
  ...Template,
}
